let fixedAdPosition = 0;
// const ad = `<div class="scroll-ad"><div class="card sticky-ad"><div class="ad ad-300"><div class="spolecznoscinet" id="spolecznosci-8041" data-min-width="1109"></div></div></div></div>`;

// export function handleSidebarAd() {
//   let doc = document.documentElement;
//   let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

//   const scrollColumns = document.getElementsByClassName("scroll-ad");
//   let offset = scrollColumns[0].offsetTop - 101;

//   const currentColumn = Math.floor((top - offset) / 3000);
//   if (currentColumn < 0) {
//     return;
//   }

//   if (currentColumn >= scrollColumns.length - 1) {
//     // remove last ad id
//     const oldAd = document.getElementById("spolecznosci-8041");
//     if (oldAd) {
//       oldAd.removeAttribute("id");
//       oldAd.removeAttribute("class");
//       oldAd.removeAttribute("key");
//       oldAd.classList.remove("spolecznoscinet");

//       if (oldAd.firstChild) {
//         oldAd.firstChild.removeAttribute("id");
//       }
//     }

//     // ad another element
//     scrollColumns[scrollColumns.length - 1].parentNode.insertAdjacentHTML("beforeend", ad);

//     // init ad
//     window._qasp.push(["sadInit", [8041]]);
//   }
// }
const ad = `<div class="scroll-ad"><div class="card sticky-ad"><div class="ad ad-300"><ins class="adsbygoogle" style="display:inline-block;width:300px;height:600px" data-ad-client="ca-pub-3051535093810095" data-ad-slot="4035208116"></ins></div></div></div>`;

export function handleSidebarAd() {
  let doc = document.documentElement;
  let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

  const scrollColumns = document.getElementsByClassName("scroll-ad");
  const footer = document.getElementById("footer");
  let offset = scrollColumns[0].offsetTop - 101;

  // console.log(footer.offsetTop, offset);

  const currentColumn = Math.floor((top - offset) / 2000);
  if (currentColumn < 0) {
    return;
  }

  if (currentColumn >= scrollColumns.length - 1 && footer.offsetTop <= currentColumn * 2000) {
    // ad another element
    scrollColumns[scrollColumns.length - 1].parentNode.insertAdjacentHTML("beforeend", ad);

    // init ad
    if (window.adsbygoogle) {
      (adsbygoogle = window.adsbygoogle || []).push({});
    }
  }
}
export function registerSidebar() {
  // let doc = document.documentElement;
  // let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

  const content = document.getElementsByClassName("memes")[0];

  const sidebar = document.getElementsByClassName("sidebar")[0];

  console.log(content.offsetHeight, sidebar);

  sidebar.style.height = content.offsetHeight - 120 + "px";
}
